import { FormProvider } from "react-hook-form";
import toast from "react-hot-toast";
import { toBaselinePayload } from "pages/patient/PatientBaselinePage/components/BaselineDetails/baselineFormConfig";
import { BaselineFormFields } from "pages/patient/PatientBaselinePage/components/BaselineDetails/BaselineFormFields.jsx";
import { useBaselineForm } from "pages/patient/PatientBaselinePage/components/BaselineDetails/useBaselineForm";

import { Button } from "components/ui/Button";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { usePatientBaseline } from "features/patients/hooks/usePatientBaseline";
import { useSavePatientBaseline } from "features/patients/hooks/useSavePatientBaseline";
import { onInvalidSubmit } from "utils/reportFormErrors";

import s from "./tabs.module.css";

// Records a new baseline reading against this consultation — the exact same
// fields/layout as the Baseline tab's own "Add Baseline" dialog (see
// pages/patient/PatientBaselinePage/components/BaselineDetails), just
// reached from the consult and saved with a consultationId so the reading
// can be traced back to the visit it was taken at.
export const BaselineTab = ({ consultationId, onSuccess }) => {
  const patientId = useCurrentPatientId();
  const { data: baseline, refetch } = usePatientBaseline(patientId);
  const saveBaseline = useSavePatientBaseline();
  const form = useBaselineForm(baseline);

  const handleSave = (data) => {
    saveBaseline.mutate(
      {
        // No id: every save is a new history row, the same as the
        // standalone Baseline tab's own form.
        patientId: Number(patientId),
        consultationId,
        ...toBaselinePayload(data),
      },
      {
        onSuccess: () => {
          toast.success("Baseline details saved successfully");
          refetch();
          onSuccess?.();
        },
        onError: (error) => {
          console.error("Failed to save baseline details:", error);
          toast.error("Failed to save baseline details. Please try again.");
        },
      }
    );
  };

  return (
    <FormProvider {...form}>
      <form
        onSubmit={form.handleSubmit(handleSave, onInvalidSubmit("BaselineTab"))}
        className={s.baselineFormContainer}
      >
        <BaselineFormFields />
        <div className={s.baselineFormActions}>
          <Button
            type="submit"
            variant="primary"
            size="large"
            disabled={saveBaseline.isPending}
          >
            {saveBaseline.isPending ? "Saving..." : "Save"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
